(ns practitest.frontend.components.run-status
  (:require [reagent.core :as reagent]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.lists :as lists]
            [practitest.frontend.common.i18n :refer [get-translation]]))

;; TODO: from backend ?
(def statuses-map
  {"PENDING"       {:translation-key "run-status.pending" :default "Pending"
                    :icon  icons/three-dots
                    :color "var(--pt-color-status-pending)"
                    :class "status-pending"}
   "RUNNING"       {:translation-key "run-status.running" :default "Running"
                    :color "var(--pt-color-status-running)"
                    :class "status-running"
                    :icon  icons/icons-spinner}
   "PASSED"        {:translation-key "run-status.passed" :default "Passed"
                    :color "var(--pt-color-success)"
                    :class "status-passed"
                    :icon  icons/check-circle-fill}
   "FAILED"        {:translation-key "run-status.failed" :default "Failed"
                    :color "var(--pt-color-error)"
                    :class "status-failed"
                    :icon  icons/x-circle-fill}
   "CANCELED"      {:translation-key "run-status.canceled" :default "Canceled"
                    :class "status-canceled"
                    :icon  icons/slash-circle
                    :color "var(--pt-color-status-canceled)"}
   "ERROR"         {:translation-key "run-status.error" :default "Error"
                    :class "status-error"
                    :color "var(--pt-color-error)"
                    :icon  icons/exclamation-circle-fill}
   "NO RUN"        {:translation-key "run-status.no-run" :default "No Run"
                    :icon  icons/file-earmark
                    :color "var(--pt-color-status-no-run)"}
   "BLOCKED"       {:translation-key "run-status.blocked" :default "Blocked"
                    :color "var(--pt-color-status-blocked)"
                    :icon  icons/dash-circle}
   "NOT COMPLETED" {:translation-key "run-status.not-completed" :default "Not Completed"
                    :color "var(--pt-color-status-not-completed)"
                    :icon  icons/file-earmark-medical}
   "N/A"           {:translation-key "run-status.na" :default "N/A"
                    :color "var(--pt-color-status-na)"
                    :icon  icons/not-applicable}})

(defn get-status-label
  [status]
  (when status
    (if-let [{:keys [translation-key default]} (get statuses-map status)]
      (get-translation translation-key default)
      (str "UNMAPPED STATUS " status))))

(defn get-status-icon
  [status]
  (when-let [icon (:icon (get statuses-map status))]
    [icon]))

(defn get-status-class
  [status]
  (:class (get statuses-map status)))

(defn get-status-color
  [status]
  (:color (get statuses-map status)))

(defn status-label
  [status]
  [:span.status
   ;; Support class/color styling
   (let [class (get-status-class status)]
     (if class
       {:class (get-status-class status)}
       {:style {:color (get-status-color status)}}))
   [:span.me-1 (get-status-icon status)]
   (get-status-label status)])
